export const gpSearchFields = [
  'startDateDoB',
  'endDateDoB',
  'postcode',
  'SchoolCode',
  'AgeGroup',
  'sex',
  'ethnicity',
  'ward',
  'imd',
  'UptoDate',
  'UpToDatePrimary',
  'UpToDate12Month',
  'UpToDatePreschool',
  'HasRefusals',
  'HasSuspensions',
  'MissingVaccine',
  'CurrentCover',
  'NextCover',
  'LocalEducationAuthority',
  'sciD_Result',
];

// PD mirrors GP, plus the GP Practice filter (a GP user is already a single practice; PD is not).
export const pdSearchFields = [...gpSearchFields, 'PracticeCode'];

export const hvSearchFields = [
  'startDateDoB',
  'endDateDoB',
  'postcode',
  'SchoolCode',
  'AgeInYears',
  'PracticeCode',
  'sex',
  'ethnicity',
  'ward',
  'imd',
  'UptoDate',
  'UpToDatePrimary',
  'UpToDate12Month',
  'UpToDatePreschool',
  'HasRefusals',
  'HasSuspensions',
  'MissingVaccine',
  'CurrentCover',
  'NextCover',
  'CohortIsNIPE72Hour',
  'CohortIsGP68WeeksReview',
  'CohortIsNewbornBloodSpotScreening',
  'CohortIsNewbornHearingScreening',
  'sciD_Result',
];

export const schoolNurseSearchFields = [
  'startDateDoB',
  'endDateDoB',
  'postcode',
  'SchoolCode',
  'SchoolYear',
  'sex',
  'ethnicity',
  'ward',
  'imd',
  'MissingVaccine',
  'LocalEducationAuthority',
  'sciD_Result',
  'ReasonNotGiven',
  'HasRefusals',
];
